export default __webpack_public_path__ + "static/media/dishwasher.a017bee5.svg";